import { chaveDoDiaEmSaoPaulo } from '@/shared/formatters/date';
import type { ConfigDoProduto, ReportBrief, ReportPlan, ReportsScope } from './types';

export const chaveDoEscopo = ({ workspaceId, produto }: ReportsScope) =>
  `${workspaceId}:${produto}`;

export const isActive = (status: string) => status === 'queued' || status === 'running';
const dateOnly = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
/** Hoje no relógio de São Paulo, o mesmo da validação do Briefing e do core, e não no do navegador. */
const hojeEmSaoPaulo = (now: Date) => {
  const [ano, mes, dia] = (chaveDoDiaEmSaoPaulo(now) ?? dateOnly(now)).split('-').map(Number);
  return new Date(ano, mes - 1, dia);
};
export function periodPreset(kind: 'month' | '30days', now = new Date()) {
  const hoje = hojeEmSaoPaulo(now);
  if (kind === 'month')
    return {
      start: dateOnly(new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1)),
      end: dateOnly(new Date(hoje.getFullYear(), hoje.getMonth(), 0)),
    };
  const start = new Date(hoje);
  start.setDate(start.getDate() - 29);
  return { start: dateOnly(start), end: dateOnly(hoje) };
}
/** O período do brief só muda quando o pedido citou um ("outubro", "desde julho"); senão fica o da tela. */
export const briefDoPlano = (
  brief: ReportBrief,
  plan: ReportPlan,
  request: string,
): ReportBrief => ({
  ...brief,
  title: plan.title,
  focus: plan.focus,
  blocks: plan.blocks,
  request,
  ...(plan.start && plan.end ? { start: plan.start, end: plan.end } : {}),
});
/** O core recusa busca maior que o título (100); trecho maior não casaria com título nenhum. */
const TAMANHO_MAXIMO_DA_BUSCA = 100;
/** O termo que vai ao servidor e o que filtra a tela são o mesmo, senão o que o servidor achou some. */
export const termoDaBusca = (search: string) => search.trim().slice(0, TAMANHO_MAXIMO_DA_BUSCA);
export const formatPeriod = (brief: Pick<ReportBrief, 'start' | 'end'>) =>
  `${brief.start.split('-').reverse().join('/')} a ${brief.end.split('-').reverse().join('/')}`;
/** UX de demonstração. A restrição real de ferramentas/escopo pertence ao agente no servidor. */
export function inferTemplate(config: ConfigDoProduto, text: string) {
  const normalized = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  if (/ignore|sql|delete|senha|codigo|receita|piada/.test(normalized)) return undefined;
  const foco = config.palavrasDoModelo.find(({ padrao }) => padrao.test(normalized))?.foco;
  return config.templates.find((template) => template.id === foco);
}
